import React, { useState, useEffect } from 'react';
import { useFormularioDinamico } from '../../../../hooks/useFormularioDinamico';

const DIAS_SEMANA = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];

export default function FormatoAguaPotable({ usuario, onBack }) {
  const {
    formulario, respuestas, loading, enviando, sedes,
    cargandoHistorial, cargarAvanceMensualAgua, handleChange, handleSubmit
  } = useFormularioDinamico('agua-potable', usuario);

  const semanaDelMesActual = Math.min(5, Math.ceil(new Date().getDate() / 7));
  const [semanaActiva, setSemanaActiva] = useState(semanaDelMesActual);
  const [mensaje, setMensaje] = useState({ text: '', type: '' });

  const [mesSeleccionado, setMesSeleccionado] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
  const [anioSeleccionado, setAnioSeleccionado] = useState(String(new Date().getFullYear()));

  // Cargar automáticamente el historial al cambiar Sede, Mes o Año
  useEffect(() => {
    if (respuestas.pdv && anioSeleccionado && mesSeleccionado) {
      const mesFiltro = `${anioSeleccionado}-${mesSeleccionado}`;
      handleChange('fechaEvento', `${mesFiltro}-01`);
      cargarAvanceMensualAgua(respuestas.pdv, mesFiltro);
    }
  }, [respuestas.pdv, anioSeleccionado, mesSeleccionado, cargarAvanceMensualAgua]);

  const matrizAgua = respuestas.matriz_semanas || [];
  const mantenimientos = respuestas.tabla_mantenimientos || [];

  const handleMedicionChange = (dia, campo, valor) => {
    const nuevaMatriz = matrizAgua.map((sem, idx) => {
      if (idx !== semanaActiva - 1) return sem;
      const nuevoDia = { ...sem.dias[dia], [campo]: valor };

      if (campo === 'cloroDato') {
        const num = parseFloat(String(valor).replace(',', '.'));
        if (!isNaN(num)) nuevoDia.cloro = num >= 0.3 && num <= 2.0 ? 'C' : 'NC';
      }
      if (campo === 'phDato') {
        const num = parseFloat(String(valor).replace(',', '.'));
        if (!isNaN(num)) nuevoDia.ph = num >= 6.5 && num <= 9.0 ? 'C' : 'NC';
      }
      return { ...sem, dias: { ...sem.dias, [dia]: nuevoDia } };
    });
    handleChange('matriz_semanas', nuevaMatriz);
  };

  const agregarMantenimiento = () => {
    handleChange('tabla_mantenimientos', [...mantenimientos, { elemento: '', fecha: '', descripcion: '', observaciones: '' }]);
  };

  const actualizarMantenimiento = (idx, campo, valor) => {
    const nuevos = [...mantenimientos];
    nuevos[idx][campo] = valor;
    handleChange('tabla_mantenimientos', nuevos);
  };

  const eliminarMantenimiento = (idx) => {
    handleChange('tabla_mantenimientos', mantenimientos.filter((_, i) => i !== idx));
  };

  const semanaTieneDatos = (numSem) => {
    const sem = matrizAgua[numSem - 1];
    if (!sem || !sem.dias) return false;
    return DIAS_SEMANA.some(dia =>
      Object.values(sem.dias[dia] || {}).some(val => String(val || '').trim() !== '')
    );
  };

  const guardarRegistroLocal = (e) => {
    if (!respuestas.pdv) {
      setMensaje({ text: '⚠️ Por favor selecciona la Sede (PDV).', type: 'warning' });
      return;
    }
    handleSubmit(e, () => {
      setMensaje({ text: `✅ Avance de la Semana ${semanaActiva} guardado con éxito.`, type: 'success' });
      setTimeout(() => setMensaje({ text: '', type: '' }), 4000);
    });
  };

  if (loading || !formulario || matrizAgua.length === 0) return <div className="p-10 text-center text-white font-bold">Cargando formato de Agua...</div>;

  const semanaActualData = matrizAgua[semanaActiva - 1] || matrizAgua[0];
  const inputClass = 'w-full h-10 px-3 bg-white/90 border border-slate-200 focus:border-sky-400 rounded-xl text-xs font-bold text-slate-800 shadow-sm outline-none';

  return (
    <div className="bg-white/20 backdrop-blur-3xl rounded-[34px] shadow-2xl max-w-6xl w-full mx-auto border border-white/30 animate-fade-in relative h-[92vh] flex flex-col">
      
      <div className="bg-gradient-to-r from-sky-600/90 to-blue-800/90 border-b border-white/20 px-6 py-4 flex items-center justify-between shadow-md shrink-0">
        <div className="flex items-center">
          <button type="button" onClick={onBack} className="mr-4 w-10 h-10 bg-white/20 text-white rounded-full flex items-center justify-center transition-all border border-white/40 cursor-pointer">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7"></path></svg>
          </button>
          <div>
            <h1 className="text-xl font-black text-white leading-tight">{formulario.titulo}</h1>
            <span className="bg-white/20 text-white border border-white/30 text-[10px] font-bold px-2 py-0.5 rounded-md mt-1 inline-block">
              {formulario.descripcion}
            </span>
          </div>
        </div>
        <button onClick={guardarRegistroLocal} disabled={enviando} className="bg-emerald-500 hover:bg-emerald-400 text-white px-6 py-2 rounded-xl text-xs font-black shadow-lg uppercase tracking-wider cursor-pointer border border-emerald-400">
          {enviando ? 'Guardando...' : `Guardar Semana ${semanaActiva}`}
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 sm:p-8 space-y-6 custom-scrollbar">
        {mensaje.text && (
          <div className={`p-4 rounded-xl text-xs font-bold flex justify-between items-center backdrop-blur-md border shadow-sm ${mensaje.type === 'success' ? 'bg-emerald-100 border-emerald-300 text-emerald-800' : 'bg-amber-100 border-amber-300 text-amber-800'}`}>
            <span>{mensaje.text}</span>
            <button onClick={() => setMensaje({ text: '', type: '' })} className="cursor-pointer font-black">✕</button>
          </div>
        )}

        {/* CABECERA FILTRADA POR ABAC */}
        <div className="bg-sky-50/90 p-5 rounded-[24px] border border-sky-200 shadow-sm grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
          <div>
            <label className="block text-[10px] font-black text-sky-800 uppercase tracking-wider mb-1.5">Mes y Año a Evaluar</label>
            <div className="flex items-center gap-2 h-10">
              <select className="w-2/3 h-full bg-white/90 border border-slate-200 rounded-xl px-2 text-xs font-bold text-slate-800 outline-none shadow-sm cursor-pointer" value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)}>
                <option value="01">Enero</option><option value="02">Febrero</option><option value="03">Marzo</option>
                <option value="04">Abril</option><option value="05">Mayo</option><option value="06">Junio</option>
                <option value="07">Julio</option><option value="08">Agosto</option><option value="09">Septiembre</option>
                <option value="10">Octubre</option><option value="11">Noviembre</option><option value="12">Diciembre</option>
              </select>
              <input type="number" className="w-1/3 h-full bg-white/90 border border-slate-200 rounded-xl px-1 text-xs font-bold text-slate-800 outline-none text-center shadow-sm" value={anioSeleccionado} onChange={e => setAnioSeleccionado(e.target.value)} />
            </div>
          </div>

          <div>
            <label className="block text-[10px] font-black text-sky-800 uppercase tracking-wider mb-1.5">Sede a Evaluar *</label>
            <select value={respuestas.pdv || ""} onChange={(e) => handleChange('pdv', e.target.value)} required className={`${inputClass} cursor-pointer`}>
              <option value="" disabled>Seleccione sede...</option>
              {sedes.map(s => <option key={s.id} value={String(s.nombre).toUpperCase()}>{s.nombre}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-[10px] font-black text-sky-800 uppercase tracking-wider mb-1.5">Inspector / Evaluador</label>
            <input type="text" value={respuestas.inspector || ""} onChange={(e) => handleChange('inspector', e.target.value)} className={inputClass} placeholder="Nombre inspector..." />
          </div>

          <div>
            <label className="block text-[10px] font-black text-sky-800 uppercase tracking-wider mb-1.5">Punto de Muestreo</label>
            <input type="text" value={respuestas.muestra_tomada_de || ""} onChange={(e) => handleChange('muestra_tomada_de', e.target.value)} className={inputClass} placeholder="Ej: Tanque, Filtro..." />
          </div>
        </div>

        {/* MATRIZ DE SEMANAS */}
        <div className="bg-white/60 backdrop-blur-md rounded-[24px] shadow-sm p-6 border border-white/80">
          <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
            <div>
              <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">Control de Calidad (Diario)</h3>
              <p className="text-[11px] font-bold text-slate-500">
                {cargandoHistorial ? <span className="text-sky-600 animate-pulse font-black">Cargando registros del mes...</span> : "Alterna entre semanas para llenar los registros diarios."}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-5 gap-2 mb-4">
            {[1, 2, 3, 4, 5].map((sem) => {
              const conDatos = semanaTieneDatos(sem);
              return (
                <button
                  key={sem} type="button" onClick={() => setSemanaActiva(sem)}
                  className={`py-3 px-2 text-xs font-black rounded-xl border transition-all cursor-pointer shadow-sm flex items-center justify-center gap-1.5 ${
                    semanaActiva === sem ? 'bg-sky-600 text-white border-sky-700 shadow-md scale-[1.02]'
                    : conDatos ? 'bg-emerald-50 text-emerald-800 border-emerald-300 hover:bg-emerald-100'
                    : 'bg-white/90 text-slate-700 border-slate-200 hover:bg-slate-50'
                  }`}
                >
                  S{sem} {conDatos && <span className="text-[10px]">✓</span>}
                </button>
              );
            })}
          </div>

          <div className="overflow-x-auto border border-white/80 rounded-2xl shadow-sm bg-white/70">
            <table className="w-full text-xs text-center border-collapse">
              <thead>
                <tr className="bg-sky-100/70 border-b border-sky-200">
                  <th className="p-3 border-r border-sky-100 text-left w-48 text-sky-900 font-black pl-4">Aspecto Evaluado</th>
                  {DIAS_SEMANA.map(dia => <th key={dia} className="p-3 border-r border-sky-100 text-sky-900 font-black">{dia}</th>)}
                </tr>
              </thead>
              <tbody>
                {['sabor', 'olor', 'color', 'materia'].map(campo => (
                  <tr key={campo} className="border-b border-white/60 hover:bg-white/80">
                    <td className="p-3 border-r border-white/60 font-black text-left uppercase text-slate-700 pl-4">{campo.replace('materia', 'Materia Extraña')}</td>
                    {DIAS_SEMANA.map(dia => (
                      <td key={dia} className="p-2 border-r border-white/60">
                        <select
                          className={`w-full border rounded-lg p-2 text-center font-black shadow-inner cursor-pointer outline-none ${
                            semanaActualData.dias[dia]?.[campo] === 'C' ? 'bg-emerald-50 text-emerald-700 border-emerald-300'
                            : semanaActualData.dias[dia]?.[campo] === 'NC' ? 'bg-red-50 text-red-700 border-red-300'
                            : 'bg-white border-gray-200'
                          }`}
                          value={semanaActualData.dias[dia]?.[campo] || ''}
                          onChange={e => handleMedicionChange(dia, campo, e.target.value)}
                        >
                          <option value="">-</option><option value="C">C</option><option value="NC">NC</option>
                        </select>
                      </td>
                    ))}
                  </tr>
                ))}
                
                <tr className="border-b border-white/60 bg-sky-50/50">
                  <td className="p-3 border-r border-white/60 font-black text-left text-blue-700 pl-4">Cloro Residual (mg/L)</td>
                  {DIAS_SEMANA.map(dia => (
                    <td key={dia} className="p-2 border-r border-white/60">
                      <input type="text" placeholder="0.3-2.0" value={semanaActualData.dias[dia]?.cloroDato || ''} onChange={e => handleMedicionChange(dia, 'cloroDato', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 text-center font-bold text-blue-700 shadow-inner outline-none focus:border-blue-400"/>
                    </td>
                  ))}
                </tr>
                <tr className="border-b border-white/60 bg-emerald-50/50">
                  <td className="p-3 border-r border-white/60 font-black text-left text-emerald-700 pl-4">PH (Dato)</td>
                  {DIAS_SEMANA.map(dia => (
                    <td key={dia} className="p-2 border-r border-white/60">
                      <input type="text" placeholder="6.5-9.0" value={semanaActualData.dias[dia]?.phDato || ''} onChange={e => handleMedicionChange(dia, 'phDato', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 text-center font-bold text-emerald-700 shadow-inner outline-none focus:border-emerald-400"/>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* TABLA DE MANTENIMIENTOS */}
        <div className="bg-white/60 backdrop-blur-md rounded-[24px] shadow-sm p-6 border border-white/80">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">Registro de Mantenimientos</h3>
            <button type="button" onClick={agregarMantenimiento} className="bg-sky-100 hover:bg-sky-200 text-sky-700 px-4 py-2 rounded-xl text-[10px] font-black shadow-sm transition-all cursor-pointer border border-sky-200 uppercase tracking-wider">+ Nuevo Mantenimiento</button>
          </div>

          {mantenimientos.length === 0 ? (
            <div className="bg-white/80 border border-dashed border-sky-200 rounded-2xl p-6 text-center shadow-inner">
              <p className="text-xs font-bold text-slate-500">No hay mantenimientos registrados aún.</p>
            </div>
          ) : (
            <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm bg-white">
              <table className="w-full text-xs border-collapse text-left">
                <thead className="bg-slate-800 text-white font-black uppercase text-[10px]">
                  <tr>
                    <th className="p-3 border-r border-slate-700">Elemento intervenido</th>
                    <th className="p-3 border-r border-slate-700">Fecha Ejecución</th>
                    <th className="p-3 border-r border-slate-700">Descripción de labor</th>
                    <th className="p-3 border-r border-slate-700">Observaciones</th>
                    <th className="p-3 text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {mantenimientos.map((mant, idx) => (
                    <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50">
                      <td className="p-2 border-r"><input type="text" value={mant.elemento} onChange={e => actualizarMantenimiento(idx, 'elemento', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 outline-none shadow-inner"/></td>
                      <td className="p-2 border-r"><input type="date" value={mant.fecha} onChange={e => actualizarMantenimiento(idx, 'fecha', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 outline-none shadow-inner"/></td>
                      <td className="p-2 border-r"><input type="text" value={mant.descripcion} onChange={e => actualizarMantenimiento(idx, 'descripcion', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 outline-none shadow-inner"/></td>
                      <td className="p-2 border-r"><input type="text" value={mant.observaciones} onChange={e => actualizarMantenimiento(idx, 'observaciones', e.target.value)} className="w-full bg-white border border-gray-200 rounded-lg p-2 outline-none shadow-sm"/></td>
                      <td className="p-2 text-center">
                        <button type="button" onClick={() => eliminarMantenimiento(idx)} className="bg-red-50 text-red-500 hover:bg-red-500 hover:text-white w-8 h-8 rounded-lg font-black transition-colors cursor-pointer border border-red-200">✕</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}